import Lenis from 'lenis';
import 'lenis/dist/lenis.css'

const lenis = new Lenis({autoRaf: true});

document.documentElement.addEventListener('turbo:before-visit', () => lenis.stop());
document.documentElement.addEventListener('turbo:before-render', () => lenis.start());
document.documentElement.addEventListener('turbo:before-frame-render', () => lenis.start());

const init = () => new ResizeObserver(() => lenis.resize()).observe(document.body);

if ('loading' === document.readyState) {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
